var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Axios from 'axios';
import isObject from 'lodash/isObject';
const URL = (...props) => `/api/v2/files/${props.join('/')}`;
export async function Upload(files = [], props) {
    const { onUploadProgress } = props, uploadProps = __rest(props, ["onUploadProgress"]);
    const formData = new FormData();
    Object.entries(uploadProps).forEach(([k, v]) => formData.append(k, v));
    files.map((file, id) => formData.append(`file[${id}]`, file));
    const { data } = await Axios.put(URL(), formData, {
        onUploadProgress: (e) => onUploadProgress === null || onUploadProgress === void 0 ? void 0 : onUploadProgress({ percentCompleted: Math.floor((e.loaded * 100) / e.total) })
    });
    return data;
}
export async function getFileInfo(id) {
    const { data } = await Axios.get(URL(id));
    return data;
}
export function getFileUrl(id, resizeParams) {
    if (!id)
        return null;
    if (typeof id === 'object')
        return id.url;
    const checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
    if (!checkForHexRegExp.test(id))
        return id;
    if (isObject(resizeParams)) {
        return `${URL('get', id)}?resize=${encodeURIComponent(JSON.stringify(resizeParams))}`;
    }
    return URL('get', id);
}
export const UploadProvider = {
    getFileUrl,
    Upload
};
